import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "@/libs/builder/commonFields";

export const videoBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Video",
  override: true,
  docsLink: "https://docs.wistia.com/docs/player-attributes-and-properties",
  inputs: [
    {
      name: "uuid",
      type: "text",
      friendlyName: "Wistia UUID",
      helperText: "Wistia UUID",
      required: true,
      localized: false,
    },
    DLD_FIELD,
    DLT_FIELD,
    {
      name: "textlink",
      friendlyName: "Text Link for Video Popup",
      type: "string",
      required: false,
      localized: true,
    },
    {
      name: "playPauseButton",
      friendlyName: "Play and Pause Button",
      type: "object",
      subFields: [
        { ...DLD_FIELD, required: false },
        { ...DLT_FIELD, required: false },
        {
          name: "dhd",
          type: "string",
          friendlyName: "Data hover details",
          localized: false,
          required: false,
        },
        {
          name: "playLabel",
          friendlyName: "Play Button Label",
          type: "string",
          required: false,
          localized: true,
        },
        {
          name: "pauseLabel",
          friendlyName: "Pause Button Label",
          type: "string",
          required: false,
          localized: true,
        },
      ],
    },
    {
      name: "autoplay",
      type: "boolean",
      helperText: "Autoplay Video",
      localized: false,
    },
    {
      name: "silentAutoplay",
      type: "boolean",
      helperText: "Videos to autoplay in a muted state",
      localized: false,
    },
    {
      name: "aspectRatio",
      type: "number",
      defaultValue: 16 / 9,
      helperText: "Aspect ratio of the player",
      required: true,
      localized: false,
    },
  ],
};
